export default __webpack_public_path__ + "static/Mac-c10eba9ecb108473fa692edf8a44e3fc.png";